function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import 'scss/plot_sample_rate_radios.scss';

var PlotSampleRateRadios =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PlotSampleRateRadios, _React$Component);

  function PlotSampleRateRadios() {
    _classCallCheck(this, PlotSampleRateRadios);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlotSampleRateRadios).apply(this, arguments));
  }

  _createClass(PlotSampleRateRadios, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.checkboxState === 'disabled') {
        this.disable();
      }
    }
  }, {
    key: "enable",
    value: function enable() {
      this.props.possibleSampleRates.map(function (sampleRate) {
        document.getElementById("sample-rate-".concat(sampleRate.abbreviation.toLowerCase())).disabled = false;
      });
    }
  }, {
    key: "disable",
    value: function disable() {
      this.props.possibleSampleRates.map(function (sampleRate) {
        document.getElementById("sample-rate-".concat(sampleRate.abbreviation.toLowerCase())).disabled = true;
      });
    }
  }, {
    key: "sampleRateRadioCheckHandlerGenerator",
    value: function sampleRateRadioCheckHandlerGenerator(selectedSampleRate) {
      var _this = this;

      return function () {
        // Don't try to update again
        if (_this.props.plotDataUpdating) return;

        _this.props.updateSelectedPlotSampleRate(selectedSampleRate);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        className: "plot-sample-rate-radios"
      }, this.props.possibleSampleRates.map(function (sampleRate, index) {
        return React.createElement("div", {
          className: "plot-sample-rate-radios__radio-wrapper",
          key: "sample-rate-".concat(sampleRate.abbreviation.toLowerCase(), "-").concat(index)
        }, React.createElement("label", {
          className: "plot-sample-rate-radios__radio-label checkbox-inline ".concat(_this2.props.checkboxState),
          htmlFor: "sample-rate-".concat(sampleRate.abbreviation.toLowerCase()),
          onClick: function onClick() {
            if (_this2.props.checkboxState === 'disabled') {
              _this2.props.showPremiumModal();
            }
          }
        }, React.createElement("input", {
          className: "plot-sample-rate-radios__radio checkbox-replaced ".concat(_this2.props.checkboxState),
          type: "radio",
          value: sampleRate.abbreviation,
          name: "sample-rate-radios",
          id: "sample-rate-".concat(sampleRate.abbreviation.toLowerCase()),
          checked: sampleRate.abbreviation === _this2.props.plotSelectedSampleRate,
          onChange: _this2.sampleRateRadioCheckHandlerGenerator(sampleRate.abbreviation)
        }), sampleRate.title, React.createElement("label", {
          className: "checkbox-replacement ".concat(_this2.props.checkboxState),
          htmlFor: "sample-rate-".concat(sampleRate.abbreviation.toLowerCase())
        })));
      }));
    }
  }]);

  return PlotSampleRateRadios;
}(React.Component);

PlotSampleRateRadios.propTypes = {
  plotDataUpdating: PropTypes.bool,
  possibleSampleRates: PropTypes.array.isRequired,
  plotSelectedSampleRate: PropTypes.string.isRequired,
  updateSelectedPlotSampleRate: PropTypes.func.isRequired,
  checkboxState: PropTypes.string.isRequired,
  showPremiumModal: PropTypes.func.isRequired
};
export { PlotSampleRateRadios as default };